module.exports = "/_next/static/images/55d1634deb71f8e349e9a0e294570346-man-looking-at-phone@md-1x.jpg.webp";